/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"MenuDesktopActivator":"MenuDesktopActivator_yU4o2","pseudoButton":"pseudoButton_hjQn2","icon":"icon_BlWe4"};